import React from 'react';

import { SVGComponentProps } from './svg.types';

const TwitterSVG = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        id="master-artboard"
        viewBox="0 0 734.3944091796875 735.7957153320312"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        width={size}
        height={size}
        {...otherProps}
      >
        <rect id="ee-background" x="0" y="0" width={size} height={size} fill="white" />
        <g transform="matrix(30.599767049153645, 0, 0, 30.599767049153645, 0, 0.7006484877169896)">
          <path
            d="M 3 0 H 21 A 3 3 0 0 1 24 3 V 21 A 3 3 0 0 1 21 24 H 3 A 3 3 0 0 1 0 21 V 3 A 3 3 0 0 1 3 0 Z"
            fill="#1DA1F2"
          />
          <path
            d="M9.00362 19.1286C15.6078 19.1286 19.2192 13.6574 19.2192 8.91309C19.2192 8.75769 19.216 8.60298 19.209 8.44898C19.9101 7.94218 20.5194 7.30972 21 6.58976C20.3567 6.87572 19.6644 7.06822 18.9381 7.15502C19.6794 6.71052 20.2485 6.00736 20.517 5.1691C19.8233 5.58035 19.055 5.87926 18.2371 6.04061C17.5819 5.3427 16.6491 4.90625 15.6162 4.90625C13.6335 4.90625 12.0256 6.51417 12.0256 8.49623C12.0256 8.77799 12.0571 9.05204 12.1187 9.31489C9.13453 9.16474 6.48851 7.73603 4.71784 5.56356C4.40949 6.09416 4.23169 6.71052 4.23169 7.36817C4.23169 8.61383 4.86554 9.71354 5.82945 10.3569C5.2404 10.3387 4.68704 10.177 4.20334 9.9078C4.20281 9.92286 4.20281 9.93755 4.20281 9.95365C4.20281 11.6925 5.44042 13.1443 7.08334 13.4733C6.78163 13.5555 6.46418 13.5996 6.13658 13.5996C5.90558 13.5996 5.68052 13.5769 5.46177 13.5349C5.91887 14.9615 7.24434 15.9996 8.81585 16.0287C7.58699 16.9919 6.03893 17.5655 4.35646 17.5655C4.06701 17.5655 3.78105 17.5491 3.5 17.5158C5.08902 18.5343 6.97588 19.1286 9.0038 19.1286"
            fill="white"
          />
        </g>
      </svg>
    </span>
  );
};

export default TwitterSVG;
